module.exports = __webpack_public_path__ + "static/media/mobile.bf081993.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/mobile.png
// module id = 303
// module chunks = 0